import type { ToolMeta } from './registry';

export const readCoachArticleMeta = {
  description:
    'Read a full curated wedding article by slug (from getCoachReference) for real depth. Use sparingly.',
  examples: ['Open the venue selection expert guide', 'Read the UK marriage laws guide'],
  value: 'the depth behind any of that',
} as const satisfies ToolMeta;
